import React, { FormEvent, useState } from 'react'

import {
  AlertType,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { useIntl } from '@app/intl/Intl'
import { bemJoin } from '@app/lib/bem'
import { Button } from '@app/lib/inputs/Button/Button'
import { Text } from '@app/lib/typography/Text/Text'
import { useSendLawyerPortalProblemReportMutation } from '@app/queries/SendLawyerPortalProblemReport/SendLawyerPortalProblemReport.queries'

import './ReportProblem.scss'

const b = bemJoin('report-problem')

type ReportProblemFormProps = {
  closeDialog: () => void
}

export const ReportProblemForm = ({ closeDialog }: ReportProblemFormProps) => {
  const [message, setMessage] = useState('')
  const { formatMessage } = useIntl()
  const { pushNotification } = useNotifications()

  const trimmedMessage = message.trim()
  const hasMessage = trimmedMessage.length > 0

  const [sendProblemReport, { loading }] = useSendLawyerPortalProblemReportMutation({
    onError: () => {
      pushNotification({
        type: AlertType.error,
        message: formatMessage({ id: 'ReportProblem.Notification.Error' })
      })
    },
    onCompleted: () => {
      pushNotification({
        type: AlertType.success,
        message: formatMessage({ id: 'ReportProblem.Notification.Success' })
      })
      closeDialog()
    }
  })

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    await sendProblemReport({ variables: { input: { message: trimmedMessage } } })
  }

  return (
    <form onSubmit={submit}>
      <Text>{formatMessage({ id: 'ReportProblem.Popup.Description' })}</Text>
      <textarea
        className={b('textarea')}
        aria-label={formatMessage({ id: 'ReportProblem.Popup.Title' })}
        placeholder={formatMessage({ id: 'ReportProblem.Popup.Textarea.Placeholder' })}
        value={message}
        onChange={(event) => setMessage(event.target.value)}
      />
      <div className={b('button-group')}>
        <Button
          type='submit'
          color='secondary'
          variant='solid'
          size='lg'
          loading={loading}
          disabled={!hasMessage}
        >
          {formatMessage({ id: 'ReportProblem.Popup.Button.Confirm' })}
        </Button>
        <Button color='secondary' variant='outlined' size='lg' onClick={closeDialog}>
          {formatMessage({ id: 'ReportProblem.Popup.Button.Cancel' })}
        </Button>
      </div>
    </form>
  )
}
